module.exports = __webpack_public_path__ + "assets/img/tab-active-img-feature1-48361217.png";